import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, BrandS } from '@sorare/core/src/atoms/typography';
import { Countdown } from '@sorare/core/src/components/Countdown';
import { Dialog } from '@sorare/core/src/components/dialog';
import { glossary } from '@sorare/core/src/lib/glossary';

type Props = {
  open: boolean;
  date: Date;
  onClose: () => void;
};

const Content = styled(Vertical)`
  padding: var(--quadruple-unit);
`;

export const UnsealingCountdownDialog = ({ open, onClose, date }: Props) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      hideHeader
      maxWidth="xs"
      fullScreen={false}
    >
      <Content gap={2} center>
        <BrandS color="var(--c-yellow-400)" uppercase>
          <FormattedMessage defaultMessage="Hold tight!" />
        </BrandS>
        <Countdown date={date} />
        <BodyM className="text-center">
          <FormattedMessage defaultMessage="You recently unsealed a card. You need to wait some time before doing it again." />
        </BodyM>
        <Button color="quaternary" onClick={onClose} size="medium" fullWidth>
          <FormattedMessage {...glossary.gotIt} />
        </Button>
      </Content>
    </Dialog>
  );
};
